<template>
  <div v-if="pills.length > 0">
    <table class="table">
      <tr>
        <th class="header-column checkbox-column">
          <!-- <v-checkbox :disabled="pills.length === 0" v-model="allSelected" /> -->
        </th>
        <th class="header-column" v-for="column in pillsColumns" :key="column.key">
          {{ $t(column.columnTranslationKey) }}
          <div
            v-if="column.key !== 'amountOfCanisters'"
            ref="orderSortIcon"
            class="header-column__icon"
            @click="sortByKey($event, column)"
          ></div>
        </th>
      </tr>
      <tr v-for="pill in sortedPills" :key="pill.id" class="item">
        <td @click.stop="() => {}" class="checkbox-column">
          <!-- <v-checkbox class="td-checkbox" :value="selectedPills.includes(pill)" @input="toggleSelected(pill)" /> -->
        </td>
        <td @click.prevent="selectItem(pill.worklistItemId || pill.id)">
          {{ (pill.medKeys || []).join(", ") }}
        </td>
        <td @click.prevent="selectItem(pill.worklistItemId || pill.id)">
          <a @click.prevent class="link">
            {{ pill.medicineName }}
          </a>
        </td>
        <td @click.prevent="selectItem(pill.worklistItemId || pill.id)">{{ pill.manufacturer }}</td>
        <td>
          <div class="counter-box actions-cell">
            <div class="v-tooltip change" v-if="pillsIncreased.some((p) => p === pill.id)">Amount was updated!</div>
            <div class="v-tooltip add" v-if="pillsAdded.some((p) => p === pill.id)">Pill was added!</div>
            <div class="v-tooltip remove" v-if="pillsRemoved.some((p) => p === pill.id)">Pill was removed!</div>

            <a href="#" id="check-data-button" class="btn btn--icon btn--bg-orange" @click.prevent="addToList(pill)">
              <i class="icon-add-list-white"></i>
              {{ $t("page.pills-list.add-to-list") }}
            </a>
            <!--
            <span
              class="counter-box__minus"
              :class="{
                'counter-box__minus--disabled': !pill.amountOfCanisters,
                'yes-pointer-events': !disabledItems.includes(pill.id),
              }"
              @click="decreaseCanister(pill)"
            >
              -
            </span>
            <span class="counter-box__number yes-pointer-events">
              <v-input
                v-if="amountEditMode === pill.id"
                :value="pill.amountOfCanisters"
                @change="setCanisterAmount(pill, $event.target.value)"
                :has-error="!$v.amountOfCanistersOnPill.between"
              />
              <span v-if="amountEditMode !== pill.id" @click="amountEditMode = pill.id">
                {{ pill.amountOfCanisters }}
              </span>
            </span>
            <span
              class="counter-box__plus"
              :class="!disabledItems.includes(pill.id) && 'yes-pointer-events'"
              @click="increaseCanister(pill)"
            >
              +
            </span>
            -->
          </div>
        </td>
      </tr>
    </table>

    <v-work-list-item-details-popup
      v-if="selectedItemId !== null"
      :list-id="workListId"
      :item-id="selectedItemId"
      :first="selectedItemId === (sortedPills[0].worklistItemId || sortedPills[0].id)"
      :last="
        selectedItemId ===
        (sortedPills[sortedPills.length - 1].worklistItemId || sortedPills[sortedPills.length - 1]).id
      "
      @next="goToNext(selectedItemId)"
      @prev="goToPrev(selectedItemId)"
      @close="$router.push({ name: 'myPills', query: { search: $route.query.search } })"
    />

    <div class="search-popup" :class="{ open: searchTooltip }">
      <span class="search-popup__close" @click="hideTooltip">
        <img src="~@/assets/icons/icon-cancel-black.svg" />
      </span>
      <img src="~@/assets/icons/icon-search-popup.svg" />
      <div class="search-popup__text">
        <h2 class="search-popup__title">{{ $t("page.order.pillnotfund.popup.title") }}</h2>
        <p class="search-popup__desc">
          {{ $t("page.order.pillnotfund.popup.description") }}
        </p>
      </div>
    </div>
  </div>
  <div v-else id="empty-pills-list-indicator" class="empty-information">
    <div class="empty-information__img">
      <img src="~@/assets/welcome-page-img5.svg" />
    </div>
    <h2 class="empty-information__title">
      {{ $t("page.pills.list.empty.title") }}
    </h2>
    <p class="empty-information__desc">
      {{ $t("page.pills.list.empty.description") }}
    </p>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import VWorkListItemDetailsPopup from "@/components/work-list/v-work-list-item-details-popup";
import * as ArrayUtils from "../../utils/ArrayUtils";
import { between } from "vuelidate/lib/validators";

export default {
  name: "VPillsList",
  components: {
    VWorkListItemDetailsPopup,
  },
  props: {
    pills: {
      type: Array,
      default: () => [],
    },
    searchQuery: {
      type: String,
      default: undefined,
    },
    clearOptions: {
      type: Boolean,
      default: false,
    },
    pillsToUpdate: {
      type: Array,
      default: undefined,
    },
    pillsToAdd: {
      type: Array,
      default: undefined,
    },
    pillsToRemove: {
      type: Array,
      default: undefined,
    },
  },
  data() {
    return {
      selectedItemId: null,
      selectedPills: [],
      sortDirection: "asc",
      sortKey: null,
      sortType: "string",
      searchTooltip: false,
      amountEditMode: null,
      amountOfCanistersOnPill: 0,
      pillsAdded: [],
      pillsIncreased: [],
      pillsRemoved: [],
      disabledItems: [],
    };
  },
  created() {
    if (sessionStorage.hideSearchTooltip == "true") {
      this.searchTooltip = false;
    } else {
      this.searchTooltip = true;
    }
  },
  computed: {
    ...mapGetters({
      workListId: "workLists/currentWorkListId",
      currentMedKeyTypeName: "medKey/currentMedKeyTypeName",
    }),
    pillsColumns() {
      return [
        {
          key: "medKeys",
          type: "string",
          columnTranslationKey: this.currentMedKeyTypeName,
        },
        {
          key: "medicineName",
          type: "string",
          columnTranslationKey: "page.order.list.header.medicinename",
        },
        {
          key: "manufacturer",
          type: "string",
          columnTranslationKey: "page.order.list.header.manufacturer",
        },
        {
          key: "amountOfCanisters",
          type: "number",
          columnTranslationKey: "",
        },
      ];
    },
    allSelected: {
      get() {
        return this.pills.length > 0 && this.selectedPills.length === this.pills.length;
      },

      set(allSelected) {
        this.selectedPills = allSelected ? [...this.pills] : [];
      },
    },
    sortedPills() {
      const pills = this.pills;
      const stringCompare = (a, b) =>
        this.sortDirection === "asc"
          ? a[this.sortKey].toString().localeCompare(b[this.sortKey].toString())
          : b[this.sortKey].toString().localeCompare(a[this.sortKey].toString());
      const numberCompare = (a, b) =>
        this.sortDirection === "asc" ? a[this.sortKey] - b[this.sortKey] : b[this.sortKey] - a[this.sortKey];
      const compare = this.sortType === "string" ? stringCompare : numberCompare;
      return this.sortKey ? pills.sort(compare) : pills;
    },
  },
  methods: {
    ...mapActions({
      increase: "pills/increase",
      decrease: "pills/decrease",
      update: "pills/update",
      setAmount: "pills/setAmount",
    }),
    toggleSelected(pill) {
      ArrayUtils.toggleInclude(this.selectedPills, pill);
    },
    sortByKey($event, { key, type }) {
      this.sortKey = key;
      this.sortType = type;
      if ($event.target.classList.contains("header-column__icon--toggle")) {
        $event.target.classList.remove("header-column__icon--toggle");
        this.sortDirection = "desc";
      } else {
        this.$refs.orderSortIcon.forEach((el) => {
          if (el.classList.contains("header-column__icon--toggle")) {
            el.classList.remove("header-column__icon--toggle");
          }
        });
        $event.target.classList.add("header-column__icon--toggle");
        this.sortDirection = "asc";
      }
    },
    async increaseCanister(pill) {
      this.disabledItems.push(pill.id);
      if (!pill.amountOfCanisters) {
        const data = await this.increase({ listId: this.workListId, pill, query: this.$route.query.search });
        if (data && data[0] && data[0].worklistItemId) {
          pill.worklistItemId = data[0].worklistItemId;
        }
        await this.addCanisterCallback(pill.id);
      } else {
        await this.update({ listId: this.workListId, pill, query: this.$route.query.search });
        await this.increaseCanisterCallback(pill.id);
      }
      this.disabledItems = this.disabledItems.filter((i) => i !== pill.id);
    },
    async setCanisterAmount(pill, value) {
      this.amountOfCanistersOnPill = value;

      if (value.match(/[^$,.\d]/) || value < 0 || value > 999) {
        return;
      }

      this.amountEditMode = null;
      this.disabledItems.push(pill.id);

      if (value < 0) {
        await this.setAmount({ listId: this.workListId, pill, value: 0, query: { search: this.$route.query.search } });
        this.decreaseCanisterCallback(pill.id);
      } else {
        await this.setAmount({ listId: this.workListId, pill, value, query: { search: this.$route.query.search } });
        this.increaseCanisterCallback(pill.id);
      }
      this.disabledItems = this.disabledItems.filter((i) => i !== pill.id);
    },
    increaseCanisterCallback(pillId) {
      this.pillsIncreased.push(pillId);
      setTimeout(() => {
        this.pillsIncreased = this.pillsIncreased.filter((p) => p !== pillId);
      }, 3000);
    },
    addCanisterCallback(pillId) {
      this.pillsAdded.push(pillId);
      setTimeout(() => {
        this.pillsAdded = this.pillsAdded.filter((p) => p !== pillId);
      }, 3000);
    },
    async decreaseCanister(pill) {
      this.disabledItems.push(pill.id);
      await this.decrease({ listId: this.workListId, pill });
      if (!pill.amountOfCanisters) {
        this.decreaseCanisterCallback(pill.id);
      } else {
        this.increaseCanisterCallback(pill.id);
      }
      this.disabledItems = this.disabledItems.filter((i) => i !== pill.id);
    },
    decreaseCanisterCallback(pillId) {
      this.pillsRemoved.push(pillId);
      setTimeout(() => {
        this.pillsRemoved = this.pillsRemoved.filter((p) => p !== pillId);
      }, 3000);
    },
    hideTooltip() {
      this.searchTooltip = false;
      sessionStorage.hideSearchTooltip = true;
    },
    goToPrev(selectedItemId) {
      const prevIndex = this.sortedPills.findIndex((pill) => pill.id === selectedItemId) - 1;
      const prevItem = this.sortedPills[prevIndex >= 0 ? prevIndex : this.sortedPills.length - 1];
      const prevItemId = prevItem.worklistItemId || prevItem.id;
      this.selectItem(prevItemId, true);
    },
    goToNext(selectedItemId) {
      const nextIndex = this.sortedPills.findIndex((pill) => pill.id === selectedItemId) + 1;
      const nextItem = this.sortedPills[nextIndex < this.sortedPills.length ? nextIndex : 0];
      const nextItemId = nextItem.worklistItemId || nextItem.id;
      this.selectItem(nextItemId, true);
    },
    selectItem(id) {
      this.$router.push({ params: { pillId: id }, query: { search: this.$route.query.search } });
    },
    addToList(pill) {
      this.setCanisterAmount(pill, "1");
      this.$emit("success");
    },
  },
  watch: {
    "$route.params.pillId": {
      handler(pillId) {
        this.selectedItemId = pillId || null;
      },
      immediate: true,
    },
    selectedPills(value) {
      this.$emit("pills-selected", value);
    },
    clearOptions(value) {
      if (value) {
        this.selectedPills = [];
      }
    },
    pillsToUpdate(value) {
      this.pillsIncreased = value.map((p) => p.id);
    },
    pillsToAdd(value) {
      this.pillsAdded = value.map((p) => p.id);
    },
    pillsToRemove(value) {
      this.pillsRemoved = value.map((p) => p.id);
    },
  },
  validations: {
    amountOfCanistersOnPill: {
      between: between(0, 999),
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables";
.table {
  th {
    &:nth-child(1) {
      width: 4%;
    }
    &:nth-child(2) {
      width: 6%;
    }
    &:nth-child(3) {
      width: 15%;
    }
    &:nth-child(4) {
      width: 14%;
    }
    &:nth-child(5) {
      width: 2%;
    }
    &:nth-child(6) {
      width: 1%;
    }
  }
  tr {
    &:hover {
      cursor: pointer;
    }
  }
}

.link {
  &:hover {
    text-decoration: underline;
  }
}

.empty-information {
  margin: 120px auto;
  width: 100%;
  max-width: 245px;
  text-align: center;
  &__image {
    margin: 0 0 0 0;
  }
  &__title {
    font-size: 24px;
    line-height: 26px;
    text-align: center;
    letter-spacing: 0.8px;
    color: #000000;
    margin: 35px 0 23px 0;
  }
  &__desc {
    font-size: 13px;
    line-height: 16px;
    text-align: center;
    letter-spacing: 0.464286px;
    color: #000000;
    margin: 23px 0 40px 0;
  }
  .button {
    padding: 12px 17px 12px 35px;
  }
}
.buttons {
  .button {
    padding: 0 0 0 24px;
    background: none;
    color: #004593;
    display: inline-block;
    white-space: nowrap;
    margin: 0 0;
    vertical-align: middle;
    &--disabled {
      color: #999999 !important;
      opacity: 0.5;
    }
    img {
      display: inline-block;
      vertical-align: middle;
    }
  }
}
.v-tooltip {
  position: absolute;
  right: 100%;
  top: -20px;
  padding: 0;
  background-color: #004593;
  background-position: 16px center;
  background-repeat: no-repeat;
  box-shadow: 0px 2px 4px rgba(153, 153, 153, 0.4);
  border-radius: 6px 6px 0px 6px;
  padding: 0 20px 0 50px;
  width: auto;
  font-size: 13px;
  height: 40px;
  line-height: 40px;
  line-height: 14px;
  display: flex;
  align-items: center;
  letter-spacing: 0.464286px;
  color: #fdfdfd;
  white-space: nowrap;
  &.remove {
    background-image: url("~@/assets/icons/icon-remove-white.svg");
  }
  &.add {
    background-image: url("~@/assets/icons/icon-add-white.svg");
  }
  &.change {
    background-image: url("~@/assets/icons/icon-change-white.svg");
  }
}
</style>
<style lang="scss">
@import "../../styles/components/counter-box";
.search-popup {
  position: fixed;
  z-index: 10;
  right: 50px;
  bottom: 50px;
  background: #fff;
  box-shadow: 0px 12px 34px rgba(153, 153, 153, 0.5);
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  width: 344px;
  padding: 20px 40px 20px 23px;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s;
  @media all and (max-width: 1200px) {
    right: 20px;
  }
  &.open {
    opacity: 1;
    visibility: visible;
  }
  &__text {
    width: calc(100% - 102px);
  }
  &__title {
    font-size: 16px;
    line-height: 17px;
    margin: 10px 0 9px 0;
    color: #000000;
  }
  &__desc {
    font-size: 13px;
    line-height: 14px;
    letter-spacing: 0.433333px;
    color: #000000;
    strong {
      font-weight: bold;
    }
  }
  &__close {
    position: absolute;
    right: 14px;
    top: 12px;
    cursor: pointer;
    img {
      width: 12px;
    }
  }
}
.actions-cell {
  min-width: 130px;
}
</style>
